import { render } from "./StickyAppBanner.vue?vue&type=template&id=ad32261c&scoped=true"
import script from "./StickyAppBanner.vue?vue&type=script&lang=js"
export * from "./StickyAppBanner.vue?vue&type=script&lang=js"

import "./StickyAppBanner.vue?vue&type=style&index=0&id=ad32261c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-iframe-br/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad32261c"]])

export default __exports__